import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import CommanBarTable_Bus from "../CommanBarTable_Bus";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Bus/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

function MaxCellVoltage_vehicles_Bus({ apiend, gloablfilter, type, chartnameFCD, maxCellVoltage_Option, maxCellVoltage_OptionMM }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF"

  const appyDataVehicles = (data) => {
    res_result = []
    res_result = data;
    let responce = {
      "<=3.10": 0,
      "3.15": 0,
      "3.20": 0,
      "3.25": 0,
      "3.30": 0,
      "3.35": 0,
      "3.40": 0,
      "3.45": 0,
      "3.50": 0,
      "3.55": 0,
      "3.60": 0,
      "3.65": 0,
      "3.70": 0,
      ">3.70": 0,
    };
    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0
      let newapiarray = []
      SetApiResponce(res_result)
      temp_result.map(d => {
        let value = d[maxCellVoltage_Option].value
        if (value != null) {
          if (value > 0 && value <= 3.10) {
            responce["<=3.10"] = responce["<=3.10"] + 1;
          } else if (value > 3.10 && value <= 3.15) {
            responce["3.15"] = responce["3.15"] + 1;
          } else if (value > 3.15 && value <= 3.20) {
            responce["3.20"] = responce["3.20"] + 1;
          } else if (value > 3.20 && value <= 3.25) {
            responce["3.25"] = responce["3.25"] + 1;
          } else if (value > 3.25 && value <= 3.30) {
            responce["3.30"] = responce["3.30"] + 1;
          } else if (value > 3.30 && value <= 3.35) {
            responce["3.35"] = responce["3.35"] + 1;
          } else if (value > 3.35 && value <= 3.40) {
            responce["3.40"] = responce["3.40"] + 1;
          } else if (value > 3.40 && value <= 3.45) {
            responce["3.45"] = responce["3.45"] + 1;
          } else if (value > 3.45 && value <= 3.50) {
            responce["3.50"] = responce["3.50"] + 1;
          } else if (value > 3.50 && value <= 3.55) {
            responce["3.55"] = responce["3.55"] + 1;
          } else if (value > 3.55 && value <= 3.60) {
            responce["3.60"] = responce["3.60"] + 1;
          } else if (value > 3.60 && value <= 3.65) {
            responce["3.65"] = responce["3.65"] + 1;
          } else if (value > 3.65 && value <= 3.70) {
            responce["3.70"] = responce["3.70"] + 1;
          } else if (value > 3.70) {
            responce[">3.70"] = responce[">3.70"] + 1;
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      const loop_keys = ["<=3.10", "3.15", "3.20", "3.25", "3.30", "3.35", "3.40", "3.45", "3.50", "3.55", "3.60", "3.65", "3.70", ">3.70"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          // "#83A4CF"
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<=3.10", "3.15", "3.20", "3.25", "3.30", "3.35", "3.40", "3.45", "3.50", "3.55", "3.60", "3.65", "3.70", ">3.70"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "volts",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'volts'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'volts',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  const [tempMaxVoltage, setTempMaxVoltage] = useState("")
  useEffect(() => {
    setTempMaxVoltage(maxCellVoltage_Option)
    SetfilteredData([])
    barcolor = "#83A4CF"
    // SetChartName("Pack A - Max Cell Voltage vehicles");
    SetChartName(chartnameFCD);
    fetchData({ url: API_URL_MAIN + "charging_api_bus/" + apiend, body: { filterdata: gloablfilter, maxCellVoltage_Option: maxCellVoltage_Option, maxCellVoltage_OptionMM: maxCellVoltage_OptionMM } }, appyDataVehicles)
  }, [gloablfilter, type, maxCellVoltage_Option])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              let filtered_temp = [];
              if (count !== 0) {
                filtered_temp = apiresponce.filter(x => {
                  if (x[tempMaxVoltage].value <= barvalue && x[tempMaxVoltage].value > barvalue - 0.05) {
                    return x;
                  }
                  else if (x[tempMaxVoltage].value > 3.70 && barvalue === ">3.70") {
                    return x
                  }
                  else if (x[tempMaxVoltage].value <= 3.10 && barvalue === "<=3.10") {
                    return x
                  }
                })

                function compareObjects(object1, object2, key) {
                  let obj1 = 0
                  let obj2 = 0
                  obj1 = object1[tempMaxVoltage].value
                  obj2 = object2[tempMaxVoltage].value
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Value</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Bus data={filteredData} tabDataKey={tempMaxVoltage} noFifty="noFifty" />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCellVoltage_vehicles_Bus;